module.exports = __webpack_public_path__ + "img/tb_patient_education_videos.48a74567.png";